import AirNoticeCarousel from './AirNoticeCarousel'

export default AirNoticeCarousel;



// WEBPACK FOOTER //
// ./src/common/components/AirNoticeCarousel/index.js